import aboutImage from '../../assets/images/home/about.png';

const About = () => {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">

        <div className="flex flex-col md:flex-row items-start">
          <div className="md:w-1/3">
            <img
              src={aboutImage}
              alt="About Grace Super Market"
              className="w-[400px] h-auto rounded-lg"
            />
          </div>
          <div className="md:w-2/3 space-y-4">
            <h2 className="text-2xl font-bold text-red-600 mb-6">Welcome to Grace Super Market</h2>
            <p className="text-gray-700">
              Grace Supermarket aims to fulfill our customers' demand and Grace Supermarket is the place every customer can purchase their choice of product efficiently and Grace Supermarket has proved that customers get the maximum convenience, comforts and on top of that it is a one – stop shopping for our customers.
            </p>
            <p className="text-gray-700">
              Grace Supermarket is one of the trouble-free chain store with a wide mix of products. Grace Supermarket is in retail industry for the past three decades and as of now it established outlets in Chennai City only and would expand our operation to tier 2 and tier 3 cities with a future expansion program of offering our service across the state. Grace Supermarket headquarter at Chennai, Tamil Nadu, Grace strives its maximum value for all its customers, employees and suppliers. Grace has built its state-of-the-art warehouse facilities at Noombal, Chennai.
            </p>
            <p className="text-gray-700">
              Grace Supermarket always accepts and incorporate innovation and the use of latest technology. Grace Supermarket always strives to create a seamless shopping experience to each one of its customers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;